import React from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import templatesAPI from "./TemplatesAPI";

const TemplateQueryKeys = {
  all: () => [{ scope: "templates" }],
};

const all = () => useQuery(TemplateQueryKeys.all(), templatesAPI.fetch);

export default {
  all,
  keyFactories: TemplateQueryKeys,
};
